<div class="password-caption__container" id="aria_password_caption">
  <span>{{passwordService.validationMessages.base}}</span>
  @if (passwordService.passwordPolicy.minimumLength > 0) {
    <span class="password-caption__hint"
      [ngClass]="{
        'password-caption__hint--error': (error || (password?.length ?? 0) > 0)
          && (password?.length ?? 0) < passwordService.passwordPolicy.minimumLength,
        'password-caption__hint--positive':
          (password?.length ?? 0) >= passwordService.passwordPolicy.minimumLength
      }">
      - {{passwordService.validationMessages.minlength}}
    </span>
  }

  @if (passwordService.passwordPolicy.requireUppercase) {
    <span class="password-caption__hint"
      [ngClass]="{
        'password-caption__hint--error': !passwordService.upperCharacterChecker(password)
          && (error || (password?.length ?? 0) > 0),
        'password-caption__hint--positive': passwordService.upperCharacterChecker(password)
          && (error || (password?.length ?? 0) > 0)
      }">
      - {{passwordService.validationMessages.uppercase}}
    </span>
  }

  @if (passwordService.passwordPolicy.requireLowercase) {
    <span class="password-caption__hint"
      [ngClass]="{
        'password-caption__hint--error': !passwordService.lowerCharacterChecker(password)
          && (error || (password?.length ?? 0) > 0),
        'password-caption__hint--positive': passwordService.lowerCharacterChecker(password)
          && (error || (password?.length ?? 0) > 0)
      }">
      - {{passwordService.validationMessages.lowercase}}
    </span>
  }

  @if (passwordService.passwordPolicy.requireNumbers) {
    <span class="password-caption__hint"
      [ngClass]="{
        'password-caption__hint--error': !passwordService.checkIfNumberContains(password)
          && (error || (password?.length ?? 0) > 0),
        'password-caption__hint--positive': passwordService.checkIfNumberContains(password)
          && (error || (password?.length ?? 0) > 0)
      }">
      - {{passwordService.validationMessages.number}}
    </span>
  }

  @if (passwordService.passwordPolicy.requireSymbols) {
    <span class="password-caption__hint"
      [ngClass]="{
        'password-caption__hint--error': !passwordService.symbolChecker(password)
          && (error || (password?.length ?? 0) > 0),
        'password-caption__hint--positive': passwordService.symbolChecker(password)
          && (error || (password?.length ?? 0) > 0)
      }">
      - {{passwordService.validationMessages.symbol}}
    </span>
  }
</div>